export const CHANTIERS = {
  GET_LIST: 'GET_CHANTIERS_LIST',
  REQUEST_LIST: 'REQUEST_CHANTIERS_LIST',
}
